import type { StyledComponent } from '@emotion/styled';
import styled from '@emotion/styled';
import type { CardProps } from '@hotjar/hotsauce';
import { tokens, Card as RawCard } from '@hotjar/hotsauce';

const CardBody = styled(RawCard.Body)`
  padding: ${tokens.spacer.x2};
`;

interface CompoundedCard extends StyledComponent<CardProps> {
  Header: typeof RawCard.Header;
  Body: typeof CardBody;
}

export const Card = styled(RawCard)`
  box-shadow: none;
  border-radius: ${tokens.radius.l};
  border: 1px solid ${tokens.color.ui_border_light};
` as CompoundedCard;

Card.Header = RawCard.Header;
Card.Body = CardBody;
